<template>
<div class="pt460" id="pt460">
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt460Init.myPage, param: {pageNo: '81'}}, {title:$t('pt430.labels.title'), routerName: pt460Init.orderHisPage, param: {pageNo: '9'}}, {title:$t('pt460.labels.orderHeader'), routerName: '', param: {}}]"></breadcrumb>
    
    <!--エラーメッセージ表示-->
    <div class="errorMessage">
        <message class="p-3" :mapMsg="listIdErr"/> 
    </div>
    <div class="searchCondition">
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div>
            <div class="itemTitle">
                <h3 v-if="siteFlg == '1'">{{$t('pt460.labels.orderHeader1')}}</h3>
                <h3 v-else>{{$t('pt460.labels.orderHeader')}}</h3>
            </div>
            <div class="orderMessage">
                <!-- ご注文の詳細です。 -->
                <p>{{$t('pt460.labels.myOrders')}}</p>
            </div>
            <table class="headerTable">
                <!-- 注文番号 -->
                <tr>
                    <th>{{$t('pt460.labels.orderNo')}}</th>
                    <td>{{orderHeadInfo.ORDER_CD_TYPICAL}}</td>
                </tr>
                <!-- 注文日 -->
                <tr>
                    <th>{{$t('pt460.labels.newdateOders')}}</th>
                    <td>{{orderHeadInfo.ORDER_TIME}}</td>
                </tr>
                <!-- 支払方法 -->
                <tr>
                    <th>{{$t('pt460.labels.newPayment')}}</th>
                    <td>{{orderHeadInfo.KESSAI_NM}}</td>
                </tr>
                <tr v-if="orderHeadInfo.HENPIN_FLG == 1">
                    <th>{{$t('common.labels.joutai')}}</th>
                    <td>{{$t('common.labels.henpin')}}</td>
                </tr>
                <template v-if="syukkaKanriFlg == 0">
                    <!-- 出荷日 -->
                    <tr v-if="orderHeadInfo.SYUKKA_YMD != null && ptInitData.notSyukaFlg != 1 && orderHeadInfo.HAISOU_SYU_FLG == 0">
                        <th>{{$t('pt460.labels.shipDate')}}</th>
                        <td>{{orderHeadInfo.SYUKKA_YMD}}</td>
                    </tr>
                    <tr v-else-if="ptInitData.notSyukaFlg != 1 && orderHeadInfo.HAISOU_SYU_FLG != 0">
                        <th>{{$t('pt460.labels.shipDate')}}</th>
                        <td>－</td>
                    </tr>
                    <!-- お問い合わせ番号 -->
                    <tr v-if="okuriInfo != null && ptInitData.notSyukaFlg != 1">
                        <th>{{$t('pt460.labels.optionLabel')}}</th>
                        <td>
                            <div v-for="(orders, index) in okuriInfo" :key="index">
                                <span v-if="orders.TRANS_CO_KBN == 'JP'">
                                    <a :href="linkJP.replace('[1]', orders.OKURINO)">{{orders.OKURINO}}</a>
                                </span>
                                <span v-else-if="orders.TRANS_CO_KBN == 'SG'">
                                    <a :href="linkSG.replace('[1]', orders.OKURINO)">{{orders.OKURINO}}</a>
                                </span>
                                <span v-else-if="orders.TRANS_CO_KBN == 'YA'">
                                    <a @click="gotoTuiseki">{{orders.OKURINO}}</a>
                                </span>
                                <span v-else>{{orders.OKURINO}}</span>
                            </div>
                        </td>
                    </tr>
                    <!-- 出荷予定日 -->
                    <tr v-if="orderHeadInfo.SYUKKA_YOTEI_YMD != null && ptInitData.notSyukaFlg != 1">
                        <th>{{$t('pt460.labels.syukkaYoteiYmd')}}</th>
                        <td v-if="orderHeadInfo.HAISOU_SYU_FLG == 0">{{orderHeadInfo.SYUKKA_YOTEI_YMD}}</td>
                        <td v-else>－</td>
                    </tr>
                    <tr v-else-if="ptInitData.notSyukaFlg != 1">
                        <th>{{$t('pt460.labels.syukkaYoteiYmd')}}</th>
                        <td v-if="orderHeadInfo.HAISOU_SYU_FLG == 0">{{$t('pt460.labels.syukkaYoteiYmdNUll')}}</td>
                        <td v-else>－</td>
                    </tr>
                </template>
            </table>
            <br>
            <div v-for="(orders, index) in orderDetailsInfo" :key="index">
                <!-- お届先情報 -->
                <p v-if="ptInitData.notSyukaFlg != 1 && orders.HAISOU_SYU_FLG == 0">{{$t('pt460.labels.DeliveryInformation')}}{{tdkIndex++}}</p>
                <p v-else-if="ptInitData.notSyukaFlg != 1 && orders.HAISOU_SYU_FLG == 1">{{$t('pt460.labels.receiveInformation')}}{{frontIndex++}}</p>
                <p v-else-if="ptInitData.notSyukaFlg != 1 && orders.HAISOU_SYU_FLG == 2">{{$t('pt460.labels.takeOutInformation')}}{{takeOutIndex++}}</p>
                <div v-for="(orders, index2) in orderDetailsInfo" :key="index2">
                    <table v-if="index == index2 && ptInitData.notSyukaFlg != 1 && orders.HAISOU_SYU_FLG == 0" class="tdkTable">
                        <!-- 配送先名 -->
                        <tr>
                            <th>{{$t('pt460.labels.deliName')}}</th>
                            <td v-if="siteFlg == '1'">
                                <span>{{orders.TDK_NM1}}</span>
                                <span>{{$t('pt460.labels.direct')}}</span>
                                <span v-if="orders.GIFT_KBN == '0'">{{$t('pt460.labels.usCompany')}}</span>
                                <span v-else >{{$t('pt460.labels.directDelivery')}}</span>
                            </td>
                            <td v-else><span >{{orders.TDK_NM1}}</span></td>
                        </tr>
                        <!-- 配送先名カナ -->
                        <tr>
                            <th>{{$t('pt460.labels.kanaName')}}</th>
                            <td>{{orders.TDK_KANA}}</td>
                        </tr>
                        <!-- 配送先郵便番号 -->
                        <tr v-if="orders.TDK_ZIP != null">
                            <th>{{$t('pt460.labels.postalCode')}}</th>
                            <td>〒{{orders.TDK_ZIP}}</td>
                        </tr>
                        <tr>
                            <div v-if="orders.TDK_FLG == '2'">
                                <tr>
                                    <th>{{$t('pt460.labels.receivingPlace')}}</th>
                                    <td>{{orders.CVS_NM}}&nbsp;{{orders.CVS_TEN_NM}}</td>
                                </tr>
                                <tr>
                                    <th>{{$t('pt460.labels.CertifiNumber')}}</th>
                                    <td>{{orders.NINSYO_CD}}</td>
                                </tr>
                            </div>
                        </tr>
                        <!-- 配送先住所 -->
                        <tr v-if="orders.TDK_ADDR1 != null">
                            <th>{{$t('pt460.labels.shipAddress')}}</th>
                            <td>{{orders.TDK_ADDR1}}{{orders.TDK_ADDR2}}{{orders.TDK_ADDR3}}</td>
                        </tr>
                        <!-- 配送先電話番号 -->
                        <tr v-if="orders.TDK_TEL1 != null">
                            <th>{{$t('pt460.labels.phoneNumber')}}</th>
                            <td>{{orders.TDK_TEL1}}</td>
                        </tr>
                        <!-- 送り主情報 -->
                        <template v-if="ecCsmInfoOption == 1 && orders.CSM_FLG == 1">
                            <!-- 送り主名 -->
                            <tr>
                                <th>{{$t('pt460.labels.okuriName')}}</th>
                                <td>{{orders.CSM_NM1}}</td>
                            </tr>
                            <!-- 送り主名カナ -->
                            <tr>
                                <th>{{$t('pt460.labels.okuriKanaName')}}</th>
                                <td>{{orders.CSM_KANA}}</td>
                            </tr>
                            <!-- 送り主郵便番号 -->
                            <tr v-if="orders.CSM_ZIP != null">
                                <th>{{$t('pt460.labels.okuriPostalCode')}}</th>
                                <td>〒{{orders.CSM_ZIP}}</td>
                            </tr>
                            <!-- 送り主住所 -->
                            <tr v-if="orders.CSM_ADDR1 != null">
                                <th>{{$t('pt460.labels.okuriShipAddress')}}</th>
                                <td>{{orders.CSM_ADDR1}}{{orders.CSM_ADDR2}}{{orders.CSM_ADDR3}}</td>
                            </tr>
                            <!-- 送り主電話番号 -->
                            <tr v-if="orders.TDK_TEL1 != null">
                                <th>{{$t('pt460.labels.okuriPhoneNumber')}}</th>
                                <td>{{orders.CSM_TEL1}}</td>
                            </tr>
                        </template>
                        <!-- 配達指定 -->
                        <tr v-if="pt460Init.tdkkibouFlg == 1 || pt460Init.tdkTimeFlg == 1">
                            <th>{{$t('pt460.labels.deliDes')}}</th>
                            <td>
                                <span v-if="pt460Init.tdkkibouFlg == 1">{{$t('pt460.labels.newDeliDate')}}&nbsp;{{orders.TDK_YMD}}</span>
                                <br>
                                <span v-if="pt460Init.tdkTimeFlg == 1">{{$t('pt460.labels.timeZone')}}&nbsp;{{orders.HSTM}}</span>
                            </td>
                        </tr>
                        <!-- ギフト指定 -->
                        <tr v-if="pt460Init.giftFlg == 1 || pt460Init.nosiFlg == 1" class="giftInfo">
                            <th>{{$t('pt460.labels.giftDes')}}</th>
                            <td>
                                <div v-if="pt460Init.giftFlg == 1" class="giftKbn">{{orders.GIFT_KBN_NM}}</div>
                                <div v-if="orders.NOSHI_NM" class="noshiNm">{{$t('pt460.labels.noshiNm')}}{{orders.NOSHI_NM}}</div>
                                <div v-if="orders.HOUSOU_NM" class="housouNm">{{$t('pt460.labels.housouNm')}}{{orders.HOUSOU_NM}}</div>
                                <div v-if="orders.OKURI_NM1" class="okuriNm1">{{$t('pt460.labels.noshiOkuriNm1')}}{{orders.OKURI_NM1}}</div>
                                <div v-if="orders.OKURI_NM2" class="okuriNm2">{{$t('pt460.labels.noshiOkuriNm2')}}{{orders.OKURI_NM2}}</div>
                                <div v-if="orders.OKURI_NM3" class="okuriNm3">{{$t('pt460.labels.noshiOkuriNm3')}}{{orders.OKURI_NM3}}</div>
                            </td>
                        </tr>
                        <!-- 配送状況 -->
                        <template v-if="shipStatus == 1">
                            <tr v-if="okuriInfo != null">
                                <th>{{$t('pt460.labels.shipStatus')}}</th>
                                <td>
                                    <span v-if="orders.ORD_KAKUTEI_FLG != 1">
                                        {{$t('pt430.labels.orderReception')}}
                                    </span>
                                    <span v-else-if="orders.ORD_KAKUTEI_FLG == 1 && orders.SHIP_KAN_FLG != 1">
                                        {{$t('pt430.labels.shipPrepare')}}
                                    </span>
                                    <span v-else-if="orders.SHIP_KAN_FLG == 1 && orders.HAI_KAN_YMD == '0000/00/00'">
                                        {{$t('pt430.labels.shipKan')}}
                                    </span>
                                    <span v-else-if="orders.HAI_KAN_YMD != null && orders.HAI_KAN_YMD != '0000/00/00'">
                                        {{$t('pt430.labels.haiKan')}}
                                    </span>
                                    <span v-else>
                                        {{$t('pt430.labels.statusErr')}}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </table>
                    <!-- 店頭受取・持帰り -->
                    <table v-if="index == index2 && ptInitData.notSyukaFlg != 1 && orders.HAISOU_SYU_FLG != 0" class="tdkTable">
                        <!-- 受取場所 -->
                        <tr v-if="orders.HAISOU_SYU_FLG == 1">
                            <th>{{$t('pt460.labels.pickupLocation')}}</th>
                            <td><span>{{orders.TDK_NM1}}</span></td>
                        </tr>
                        <!-- 受取指定 -->
                        <tr v-if="pt460Init.tdkkibouFlg == 1 || pt460Init.tdkTimeFlg == 1">
                            <th>{{$t('pt460.labels.receiveDesignation')}}</th>
                            <td>
                                <span v-if="pt460Init.tdkkibouFlg == 1">{{$t('pt460.labels.receiveDate')}}&nbsp;{{orders.TDK_YMD}}</span>
                                <br>
                                <span v-if="pt460Init.tdkTimeFlg == 1 && orders.HAISOU_SYU_FLG == 1">{{$t('pt460.labels.receiveTime')}}&nbsp;{{orders.HSTM}}</span>
                            </td>
                        </tr>
                        <!-- ギフト指定 -->
                        <tr v-if="pt460Init.giftFlg == 1 || pt460Init.nosiFlg == 1" class="giftInfo">
                            <th>{{$t('pt460.labels.giftDes')}}</th>
                            <td>
                                <div v-if="pt460Init.giftFlg == 1" class="giftKbn">{{orders.GIFT_KBN_NM}}</div>
                                <div v-if="orders.NOSHI_NM" class="noshiNm">{{$t('pt460.labels.noshiNm')}}{{orders.NOSHI_NM}}</div>
                                <div v-if="orders.HOUSOU_NM" class="housouNm">{{$t('pt460.labels.housouNm')}}{{orders.HOUSOU_NM}}</div>
                                <div v-if="orders.OKURI_NM1" class="okuriNm1">{{$t('pt460.labels.noshiOkuriNm1')}}{{orders.OKURI_NM1}}</div>
                                <div v-if="orders.OKURI_NM2" class="okuriNm2">{{$t('pt460.labels.noshiOkuriNm2')}}{{orders.OKURI_NM2}}</div>
                                <div v-if="orders.OKURI_NM3" class="okuriNm3">{{$t('pt460.labels.noshiOkuriNm3')}}{{orders.OKURI_NM3}}</div>
                            </td>
                        </tr>
                    </table>
                </div>
                <br>
                <table class="itemTable1">
                    <thead>
                        <tr>
                            <!-- 商品コード -->
                            <th scope="col">{{$t('common.labels.productCode')}}</th>
                            <!-- 商品名 -->
                            <th scope="col">{{$t('common.labels.productName')}}</th>
                            <!-- 単価-->
                            <th scope="col" v-if="pt460Init.priceShow != 1">{{$t('common.labels.unitPrice')}}</th>
                            <!-- 数量 -->
                            <th scope="col">{{$t('common.labels.quantity')}}</th>
                            <!--匹数-->
                            <th v-if="pt460Init.auraOption == 1" scope="col">{{$t('common.labels.animalQty')}}</th>
                            <!-- 金額 -->
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1' && pt460Init.priceShow != 1" scope="col">
                                {{$t('pt460.labels.kingakuStr')}}
                                <span>{{$t('common.labels.taxincluded')}}</span>
                            </th>
                            <th v-else-if="pt460Init.priceShow != 1" scope="col">
                                {{$t('pt460.labels.kingakuStr')}}
                                <span>{{$t('common.labels.excludingtax')}}</span>
                            </th>
                            <!-- レビュー-->
                            <th scope="col" v-if="reviewFlg == 1 && (reviewToukouFlg == 0 || (reviewToukouFlg == 1 && orders.TOIOUT_FLG == 1))">商品レビュー</th>
                            <!-- デジタル情報 -->
                            <th v-if="pt460Init.digitalDisp == 1" scope="col">{{$t('common.labels.digitalId')}}</th>
                            <th v-if="pt460Init.digitalDisp == 2" scope="col">{{$t('common.labels.barcode')}}</th>
                            <th v-if="pt460Init.digitalDisp == 3" scope="col">{{$t('common.labels.idAndBarcode')}}</th>
                            <!-- のし#73022 
                            <th  scope="col" v-if="noshiOption == 1 ">{{$t('pt460.labels.noshiSetting')}}</th>-->
                        </tr>
                    </thead>
                    <tbody v-for="(orders2,index) in orderProductsInfo" :key="index" >
                        <tr v-if="orders.ORDER_NO == orders2.ORDER_NO " :style="('background-color : ' + [orders2.ORDER_JOKYO_KBN == 'C' ? trColor : '',''])" >
                            <!--商品CD -->
                            <td scope="row" :aria-label="$t('common.labels.productCode')">{{orders2.S_ITEM_CD}}</td>
                            <!--商品名 -->
                            <td :aria-label="$t('common.labels.productName')">
                                <span v-if="orders2.ORDER_JOKYO_KBN == 'C'" style="color:white;">{{$t('pt460.labels.cancelMessage')}}</span>{{orders2.ITEM_NM}}
                                <div v-html="orders2.NOSHI_INFO"></div>
                                <div v-html="orders2.BIKOU"></div>
                            </td>
                            <!--単価-->
                            <td v-if="orderHeadInfo.TNK_DSP_KBN == '1' && pt460Init.priceShow != 1" :aria-label="$t('common.labels.unitPrice')">
                                <span>
                                    <input-number v-model="orders2.TNK_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <td v-else-if="pt460Init.priceShow != 1" :aria-label="$t('common.labels.unitPrice')">
                                <span>
                                    <input-number v-model="orders2.TNK_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <!--数量 -->
                            <td :aria-label="$t('common.labels.quantity')">{{formatPrice(orders2.QTY)}}</td>
                            <!--匹数-->
                            <td v-if="pt460Init.auraOption == 1 && orders2.SYUKKA_NUM > 1" :aria-label="$t('common.labels.animalQty')">
                                {{formatPrice(orders2.ANIMAL_QTY)}}
                            </td>
                            <td v-else-if="pt460Init.auraOption == 1" :aria-label="$t('common.labels.animalQty')">{{"-"}}</td>
                            <!--金額(税込) -->
                            <td v-if="orderHeadInfo.TNK_DSP_KBN == '1' && pt460Init.priceShow != 1" :aria-label="$t('pt460.labels.kingakuStr')+$t('common.labels.taxincluded')">
                                <span>
                                    <input-number v-model="orders2.IN_QTY" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <!--金額(税抜) -->
                            <td v-else-if="pt460Init.priceShow != 1" :aria-label="$t('pt460.labels.kingakuStr')+$t('common.labels.excludingtax')">
                                <span>
                                    <input-number v-model="orders2.EX_QTY" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <!-- レビュー -->
                            <td v-if="reviewFlg == 1 && (reviewToukouFlg == 0 || (reviewToukouFlg == 1 && orders.TOIOUT_FLG == 1))">
                                <span>
                                    <a v-if="orders2.REVIEW_SYORI_KBN == 0" @click="pt460review(orders2.S_ITEM_CD,orderHeadInfo.ORDER_CD_TYPICAL, orders2.SEQ)">{{$t('pt460.labels.review')}}</a>
                                </span>
                            </td>
                             <!--デジタル情報 -->
                            <td v-if="orders2.DIGITAL_ITEM_TYPE == 1 && orders2.ITEM_KBN == 6" :aria-label="$t('common.labels.digitalId')" >
                                <div v-if="orders2.DIGITAL_ID != null">
                                    ID:{{orders2.DIGITAL_ID}}
                                </div>
                                <div v-else>
                                    ID: {{$t('common.labels.inPreparation')}}
                                </div>
                                <span v-if="orders2.FIXED_URL != null">
                                    <a :href="orders2.FIXED_URL" target="_blank">{{orders2.FIXED_URL}}</a>
                                </span>
                            </td>
                            <td v-if="orders2.DIGITAL_ITEM_TYPE == 2 && orders2.ITEM_KBN == 6" :aria-label="$t('common.labels.digitalId')">
                                <span v-if="orders2.FIXED_BAR_URL != null">
                                    <a href="#" @click.prevent="openBarcode(orders2.FIXED_BAR_URL)">{{ $t('common.labels.barcodeDisp') }}</a>
                                </span>
                                <span v-else>
                                    {{$t('common.labels.inPreparation')}}
                                </span>
                            </td>
                            <!-- のし #73022
                            <td v-if="noshiOption == 1 && orders2.NOSHI_FLG >= 1">
                                <span>
                                    <input type="button" @click="doShowNoshi(orders2.ORDER_NO,orders2.ORDER_LINE_NO,orders2.ITEM_NM)" :value="$t('pt460.buttons.showNoshi')">
                                </span>
                            </td>-->
                        </tr>
                    </tbody>
                </table>
                <template v-if="pointItemDispFlg">
                    <table class="itemTable12">
                        <thead>
                            <tr>
                                <!-- 商品コード -->
                                <th scope="col">{{$t('common.labels.productCode')}}</th>
                                <!-- 商品名 -->
                                <th scope="col">{{$t('common.labels.productName')}}</th>
                                <!-- ポイント数-->
                                <th scope="col">{{$t('pt460.labels.pointsu')}}</th>
                                <!-- 数量 -->
                                <th scope="col">{{$t('common.labels.quantity')}}</th>
                                <!-- 合計 -->
                                <th scope="col">{{$t('pt460.labels.pointkei')}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="(orders3,index) in orderProductsPointInfo" :key="index">
                            <tr v-if="orders.ORDER_NO == orders3.ORDER_NO " :style="('background-color : ' + [orders2.ORDER_JOKYO_KBN == 'C' ? trColor : '',''])">
                                <!--商品CD -->
                                <td scope="row" :aria-label="$t('common.labels.productCode')">
                                    {{orders3.S_ITEM_CD}}
                                </td>
                                <!--商品名 -->
                                <td :aria-label="$t('common.labels.productName')">
                                    <span v-if="orders2.ORDER_JOKYO_KBN == 'C'" style="color:white;">{{$t('pt460.labels.cancelMessage')}}</span>{{orders3.ITEM_NM}}
                                    <div v-html="orders3.BIKOU"></div>
                                </td>
                                <!-- ポイント数 -->
                                <td :aria-label="$t('pt460.labels.pointsu')">
                                    <span>
                                        <input-number v-model="orders3.I_POINT" :readonly="true" :suffix ="'pt'"/>
                                    </span>
                                </td>
                                <!-- 数量 -->
                                <td :aria-label="$t('common.labels.quantity')">
                                    {{orders3.QTY}}
                                </td>
                                <!-- 合計 -->
                                <td :aria-label="$t('pt460.labels.pointkei')">
                                    <span>
                                        <input-number v-model="orders3.K_POINT" :readonly="true" :suffix ="'pt'"/>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
            <div v-if="bikouFlg == 1">
                <!-- 備考 -->
                <p>{{$t('pt460.labels.bikou')}}</p>
                <div class="bikouTable">
                    <table>
                        <tr>
                            <td>
                                {{orderHeadInfo.ORDER_BIKO}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row" v-if="pt460Init.priceShow != 1">

                <div class="ml-auto mr-0" v-if="syouhiZeiDispFlg == 1">
                    <table class="totalTable">
                        <!-- 10%対象税込計 -->
                        <tr v-if="orderHeadInfo.TNK_DSP_KBN == '1' && orderHeadInfo.TOTAL_TAX_RT1_IN > 0">
                            <th>{{$t('sh060.labels.totalTaxRt1TaxInTitle')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT1_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 10%対象税抜計 -->
                        <tr v-if="orderHeadInfo.TNK_DSP_KBN == '2' && orderHeadInfo.TOTAL_TAX_RT1_EX > 0">
                            <th>{{$t('sh060.labels.totalTaxRt1TaxExTitle')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT1_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 10%消費税 -->
                        <tr v-if="orderHeadInfo.TOTAL_TAX_RT1_TAX > 0">
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                                <!-- 10%内消費税 -->
                                {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.newConsumption')}}
                            </th>
                            <th v-else>
                                <!-- 10%消費税 -->
                                {{$t('sh060.labels.totalTaxRt1TaxTitle') + $t('common.labels.consumptionTax')}}
                            </th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT1_TAX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>

                        <!-- 8%対象税込計 -->
                        <tr v-if="orderHeadInfo.TNK_DSP_KBN == '1' && orderHeadInfo.TOTAL_TAX_RT2_IN > 0">
                            <th>{{$t('sh060.labels.totalTaxRt2TaxInTitle')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT2_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 8%対象税抜計 -->
                        <tr v-if="orderHeadInfo.TNK_DSP_KBN == '2' && orderHeadInfo.TOTAL_TAX_RT2_EX > 0">
                            <th>{{$t('sh060.labels.totalTaxRt2TaxExTitle')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT2_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 8%消費税 -->
                        <tr v-if="orderHeadInfo.TOTAL_TAX_RT2_TAX > 0">
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                                <!-- 8%内消費税 -->
                                {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.newConsumption')}}
                            </th>
                            <th v-else>
                                <!-- 8%消費税 -->
                                {{$t('sh060.labels.totalTaxRt2TaxTitle') + $t('common.labels.consumptionTax')}}
                            </th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT2_TAX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>

                        <!-- 非課税対象計 -->
                        <tr v-if="orderHeadInfo.TOTAL_TAX_RT3_EX > 0">
                            <th>{{$t('sh060.labels.totalTaxRt3Title')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.TOTAL_TAX_RT3_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="ml-auto mr-0">
                    <table class="totalTable">
                        <!-- 小計 -->
                        <tr>
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                                {{$t('sh060.labels.itemValueSubtotalin')}}
                            </th>
                            <th v-else>
                                {{$t('sh060.labels.itemValueSubtotalex')}}
                            </th>
                            <td>
                                <span v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                                    <input-number v-model="orderHeadInfo.ITEMSUM_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                                <span v-else>
                                    <input-number v-model="orderHeadInfo.ITEMSUM_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 送料 -->
                        <template v-if="soryoDispFlg == 1">
                            <tr>
                                <th>{{$t('pt460.labels.cost')}}</th>
                                <td>
                                    <span>
                                        <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.SORYO_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                        <input-number v-else v-model="orderHeadInfo.SORYO_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                    </span>
                                </td>
                            </tr>
                        </template>
                        <!-- 代引手数料 -->
                        <tr v-if="orderHeadInfo.KESSAI_CD == '2'">
                            <th>{{$t('pt460.labels.cod')}}</th>
                            <td>
                                <span>
                                    <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.DAI_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                    <input-number v-else v-model="orderHeadInfo.DAI_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 払込手数料 -->
                        <tr v-if="orderHeadInfo.KESSAI_CD == '3'">
                            <th>{{$t('sh060.labels.paymentslipfee')}}</th>
                            <td>
                                <span>
                                    <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.PAY_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                    <input-number v-else v-model="orderHeadInfo.PAY_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 決済手数料 -->
                        <tr v-if="orderHeadInfo.KESSAI_CD == '80' || orderHeadInfo.KESSAI_CD == '4'">
                            <th>{{$t('sh060.labels.kessaiTesuTitle')}}</th>
                            <td>
                                <span>
                                    <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.KESSAI_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                    <input-number v-else v-model="orderHeadInfo.KESSAI_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!--利用ポイント -->
                        <tr v-if="stringNvl(orderHeadInfo.POINT_USED,'0') != '0' || stringNvl(orderHeadInfo.GAIBU_POINT_USED,'0') != '0' ">
                            <th>{{$t('sh060.labels.pointstousethistime')}}</th>
                            <td>
                                <span>
                                    <input-number v-if="stringNvl(orderHeadInfo.POINT_USED,'0') != '0'" v-model="orderHeadInfo.POINT_USED" :readonly="true" :suffix = "$t('sh050.labels.pt')"/>
                                    <input-number v-else-if="stringNvl(orderHeadInfo.GAIBU_POINT_USED,'0') != '0'" v-model="orderHeadInfo.GAIBU_POINT_USED" :readonly="true" :suffix = "$t('sh050.labels.pt')"/>
                                </span>
                            </td>
                        </tr>
                        <!-- キャンペーン値引 -->
                        <tr v-if="stringNvl(orderHeadInfo.NEBIKI,'0') != '0'">
                            <th>{{$t('sh060.labels.campaigndiscount')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.NEBIKI" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- クーポン値引き -->
                        <tr v-if="stringNvl(orderHeadInfo.COUPON_USED,'0') != '0'">
                            <th>{{$t('sh060.labels.orderCouSettArea')}}</th>
                            <td>
                                <span>
                                    <input-number v-model="orderHeadInfo.COUPON_USED" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                        <!-- 消費税 -->
                        <template>
                            <tr>
                                <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'">{{$t('pt460.labels.newConsumption')}}</th>
                                <th v-else>{{$t('pt460.labels.consumptionTax')}}</th>
                                <td>
                                    <span>
                                        <input-number v-model="orderHeadInfo.SEIKYU_TAX" :readonly="true" :suffix ="'円'"/>
                                    </span>
                                </td>
                            </tr>
                        </template>

                        <!-- 請求金額 -->
                        <template v-if="seikyuuKinDispFlg == 1">
                            <tr>
                                <th>
                                    {{$t('sh060.labels.billedamount(taxincluded)')}}
                                </th>
                                <td>
                                    <span>
                                        <input-number v-model="orderHeadInfo.SEIKYU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
            </div>

            <div v-if="optionFlg == 1">{{$t('pt460.labels.orderOptionDis')}}</div>
            <ul class="buttonColumn">
                <!-- 前のページへ戻る -->
                <li>
                    <router-link :to="generateLinkParams(backPageNo, backUrl, {ptPageNo: requestBack.ptPageNo, ptPageSize: requestBack.ptPageSize, sKbn: requestBack.sKbn, rKbn: requestBack.rKbn, ptOrderByType: requestBack.ptOrderByType})" class="btnSubmit" name="submitButtonName">
                        {{$t('common.labels.backButton')}}
                    </router-link>
                </li>
                <template v-if="orderHeadInfo.KOKYAKU_OYA_FLG == 1">
                    <!-- 再注文 -->
                    <li v-if="reOrderFlg == 1 && optionFlg == 0 && newOrderNgFlg == 0">
                        <input class="btnSubmit" type="submit" name="submitButtonName" id="addOrderBtn" @click="pt460reOderAllowSameItemAddCheck()" onkeypress="pt460reOderAllowSameItemAddCheck()" :value="$t('common.labels.buttonOders')">
                    </li>
                    <!--注文変更 -->
                    <li v-if="loginSiteCd == orderHeadInfo.SITE_CD && orderChangeFlg == 1 && orderKakuteiFlg == 0 && cancelFlg == 0 && eigyoDayFlg == 1 && multTdkFlg == 0">
                        <input class="btnSubmit" type="submit" name="submitButtonName" id="updateOrderBtn" @click="pt460orderChange()" onkeypress="pt460orderChange()" :value="$t('pt460.buttons.change')">
                    </li>
                    <!--注文キャンセル -->
                    <li v-if="loginSiteCd == orderHeadInfo.SITE_CD && orderCancelFlg == 1 && orderKakuteiFlg == 0 && cancelFlg == 0 && eigyoDayFlg == 1">
                        <input class="btnSubmit" type="submit" name="submitButtonName" id="cancelOrderBtn" @click="pt460orderCancel()" onkeypress="pt460orderCancel()" :value="$t('common.buttons.cancel')">
                    </li>
                </template>
            </ul>
            <br>
        </div><!-- /.section-inner -->
    </div><!-- /.section page-mypage mb32 -->

    <!-- ※バーコード情報※ -->
    <b-modal v-model="isModalBarcode"
        size="md"
        centered
        :title="$t('common.labels.barcode')"
        :footer-class="'mx-auto'">
        <div class="mx-auto">
            <img class="barcodeImg" :src="barCodeImg" :alt="$t('common.labels.barcode')">
        </div>
        <div slot="modal-footer">
            <!-- 閉じる -->
            <input @click="isModalBarcode = false" :value="$t('pt430.buttons.close')" type="button">
        </div>
    </b-modal>

</div>  
</template>

<script>
/* 
* Import libs and componnents 
*/
import axios from "assets/js/request";
import common from "assets/js/common";
import DataTable from 'components/Datatable';
import InputCheck from 'components/InputCheck';
import Message from 'components/Message';
import DownloadFile from 'components/DownloadFile';
import DatePickers from 'components/DatePicker';
import InputNumber from "components/InputNumber";
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /* 
    * Name of component
    */
    name: "PT460MemberOrderHisDetParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        },
        dataRef: {}

    },

    /* 
    * Declare components
    */
    components: {
        DataTable,
        Message,
        DatePickers,
        InputCheck,
        DownloadFile,
        InputNumber,
        Breadcrumb
    },
    /* 
    * Declare variable and set default value
    */
    data: function() {
        return {
            listIdErr:[],
            orderDetailsInfo:[],
            okuriInfo:[],
            orderProductsInfo:[],
            orderProductsPointInfo:[],
            orderHeadInfo:{},
            orderTotInfo:{},
            reqModel:{
                fBaFLG:null,
                orderCdTypical:null,
                orderNo: null,
                returnPage:null
            },
            pt460reqModel:{
                fBaFLG:null,
                orderNo:null,
                orderCdTypical:null,
                pointFlg:0
            },
            pt460Init: {},
            siteFlg: null,
            requestBack:{},
            SiteConstants:SiteConstants,
            soryoKin: null,
            uketoriKin: null,
            usePoint: null,
            linkJP: null,
            linkSG: null,
            linkYA: null,
            orderCancelFlg: null,
            orderKakuteiFlg: null,
            orderChangeFlg: null,
            cancelFlg: null,
            reviewFlg: 0,
            noshiOption: 0,
            reviewToukouFlg: 0,
            syukkaKanriFlg: 0,
            shipStatus: 0,
            site: "",
            loginSiteCd:"",
            soryoDispFlg:0,
            syouhiZeiDispFlg:0,
            reOrderFlg:0,
            eigyoDayFlg:0,
            multTdkFlg:1,
            seikyuuKinDispFlg:0,
            ecCsmInfoOption:0,
            pointItemDispFlg: false,
            trColor: '#a9a9a9;',
            optionFlg:0,
            bikouFlg:0,
            nosiFlg:0,
            newOrderNgFlg: 0,
            isModalBarcode: false,
            barCodeImg: '',
            backPageNo: 1,
            backUrl: "",
        }
    },
    /* 
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        
        //Call API doInit
        if (_this.ptInitData){
            _this.pt460Init = _this.ptInitData;
            _this.pt460reqModel = Object.assign({}, _this.pt460reqModel, _this.pt460Init.reqModels);
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT460 + _this.$UrlConstants.DO_INIT, _this.pt460reqModel).then(function(response) {
                _this.pt460Init = response.data;
                _this.pt460reqModel = Object.assign({}, _this.pt460reqModel, response.data.reqModels);
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        _this.orderDetailsInfo = _this.pt460Init.orderDetailsInfo;
        _this.okuriInfo = _this.pt460Init.okurinoInfo;
        _this.orderProductsInfo = _this.pt460Init.orderProductsInfo;
        _this.orderProductsPointInfo = _this.pt460Init.orderProductsPointInfo;
        if (_this.orderProductsInfo != null && _this.orderProductsInfo != '') {
            for (var i = 0 ; i < _this.orderProductsInfo.length; i++) {
                if (_this.orderProductsInfo[i].BIKOU != null) {
                    _this.optionFlg = 1;
                }
            }
        }
        if (_this.orderProductsPointInfo != null && _this.orderProductsPointInfo != '') {
            _this.pointItemDispFlg = true;
            for (var j = 0 ; j < _this.orderProductsPointInfo.length; j++) {
                if (_this.orderProductsPointInfo[j].BIKOU != null) {
                    _this.optionFlg = 1;
                }
            }
        }
        _this.orderTotInfo = _this.pt460Init.orderTotInfo[0];
        _this.orderHeadInfo = _this.pt460Init.orderHeadInfo[0];
        _this.soryoKin = _this.pt460Init.soryoKin;
        _this.uketoriKin = _this.pt460Init.uketoriKin;
        _this.usePoint = _this.pt460Init.usePoint;
        _this.orderCancelFlg = _this.pt460Init.orderCancelFlg;
        _this.orderKakuteiFlg = _this.pt460Init.orderKakuteiFlg;
        _this.orderChangeFlg = _this.pt460Init.orderChangeFlg;
        _this.cancelFlg = _this.pt460Init.cancelFlg;
        _this.reviewFlg = _this.pt460Init.reviewFlg;
        _this.noshiOption = _this.pt460Init.noshiOption;
        _this.nosiFlg = _this.pt460Init.nosiFlg;
        _this.bikouFlg = _this.pt460Init.bikouFlg;
        _this.reviewToukouFlg = _this.pt460Init.reviewToukouFlg;
        _this.syukkaKanriFlg = _this.pt460Init.syukkaKanriFlg;
        _this.shipStatus = _this.pt460Init.shipStatus;
        _this.soryoDispFlg = _this.pt460Init.soryoDispFlg;
        _this.syouhiZeiDispFlg = _this.pt460Init.syouhiZeiDispFlg;
        
        _this.loginSiteCd = _this.pt460Init.loginSiteCd;
        _this.reOrderFlg = _this.pt460Init.reOrderFlg;
        _this.eigyoDayFlg = _this.pt460Init.eigyoDayFlg;
        _this.multTdkFlg = _this.pt460Init.multTdkFlg;
        _this.seikyuuKinDispFlg = _this.pt460Init.seikyuuKinDispFlg;
        _this.ecCsmInfoOption = _this.pt460Init.ecCsmInfoOption;
        _this.newOrderNgFlg = _this.pt460Init.newOrderNgFlg;
        //Replace link
        _this.linkJP = _this.pt460Init.linkJP;
        _this.linkSG = _this.pt460Init.linkSG;
        _this.linkYA = _this.pt460Init.linkYA;

        // 定期一覧URL
        if(_this.pt460reqModel.returnPage == 'TK035'){
            _this.backPageNo = 88;
            _this.backUrl = _this.pt460Init.teikiListPage;
        // 購入履歴一覧URL
        }else{
            _this.backPageNo = 9;
            _this.backUrl = _this.pt460Init.orderHisPage;
        }
    },
    /* 
    * Methods
    */
    methods: {
        /* 
        * Function order 
        */
        pt460reOderAllowSameItemAddCheck: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.pt460reqModel.yobiCd5 = _this.orderHeadInfo.YOBI_CD5;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_ORDER, _this.pt460reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                     _this.$emit("event-loading", false);
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        var info = "";
                        for(var mesg = 0;  mesg < response.data.response.info.length; mesg++ ){
                            info = info + response.data.response.info[mesg].messageList[0].message;
                            info = info + '\n';
                        }
                        alert(info);
                    } 
                    if (response.data.response.hasItemAdded != null && response.data.response.hasItemAdded == 1){
                            if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                                    info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                                    info = info + '\n';
                                alert(info);
                            } 
                            if (_this.orderHeadInfo.YOBI_CD5) {
                                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22},params: { reOrderFlg: 1}});
                            } else {
                                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                            }
                    } else {
                        if (_this.orderHeadInfo.YOBI_CD5) {
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22, reOrderFlg:1}});
                        } else {
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                        }
                    }
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        openBarcode: function(imageUrl){
            this.isModalBarcode=true;
            const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
            this.barCodeImg = baseUrl + imageUrl;
        },
        /*
        * しの情報照会
        */
        doShowNoshi:function(orderNo,lineNo,itemNm1){
            this.$router.push({ name: this.SiteConstants.PG010MAIN
                ,params: {dispOnly : 1
                    ,backPageNo:10
                    ,backOrderNo:orderNo
                    ,backOrderCdTypical:this.pt460reqModel.orderCdTypical
                    ,backFBaFlg:this.pt460reqModel.fBaFLG
                    ,requestBack:this.requestBack
                    ,orderNo:orderNo
                    ,orderLineNo:lineNo
                }
                , query: {pageNo: 26}});
        },
        /* 
        * Function order 
        */
        pt460reOder: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_ORDER, _this.pt460reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        alert(response.data.response.info);
                    } else {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        pt460orderCancel: function(){
            var _this = this;
            if (!confirm( _this.$i18n.t('pt460.labels.orderCancelMessage') )) return;
            _this.$emit("event-loading", true);
            _this.listIdErr = [];
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT460 + _this.$UrlConstants.DO_CANCEL, _this.pt460reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    const parameter = _this.generateLinkParams(9,_this.pt460Init.orderHisPage);
                    _this.$router.push(parameter);
                } else {
                    alert('注文確定済みのためキャンセルできませんでした。');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        // 商品レビュー画面へ
        pt460review: function(itemCd,orderCd,seq) {
            var _this = this;
            const parameter = _this.generateLinkParams(83,_this.pt460Init.reviewPage, {itemCd: itemCd},{orderCd: orderCd,itemCd: itemCd,seq: seq});
            _this.$router.push(parameter);
        },
        //function back
        backStep: function(){
            var _this = this;
            //定期一覧から遷移時、戻り先は定期一覧にする
            if(_this.pt460reqModel.returnPage == 'TK035'){
                const parameter = _this.generateLinkParams(88,_this.pt460Init.teikiListPage);
                _this.$router.push(parameter);
            }else{
                const parameter = _this.generateLinkParams(9,_this.pt460Init.orderHisPage);
                _this.$router.push(parameter);
            }
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        /* 
        * Function 注文変更処理
        */
        pt460orderChange: function(){
            var _this = this;
            if (!confirm( _this.$i18n.t('pt630.labels.changeMessage') )) return;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_ORDER_CHANGE, _this.pt460reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                     _this.$emit("event-loading", false);
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        var info = "";
                        for(var mesg = 0;  mesg < response.data.response.info.length; mesg++ ){
                            info = info + response.data.response.info[mesg].messageList[0].message;
                            info = info + '\n';
                        }
                        alert(info);
                    } 
                    if (response.data.response.hasItemAdded != null && response.data.response.hasItemAdded == 1){
                            if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                                info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                                info = info + '\n';
                                alert(info);
                            } 
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    } else {
                        if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                            info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                            info = info + '\n';
                            alert(info);
                        } 
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    }
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        gotoTuiseki: function() {
            let tuisekiLink = '';
            let param = '';
            tuisekiLink = this.pt460Init.linkYA;
            param = this.pt460Init.yaTuisekiParam;

            let linkUrl = this.settingUrl(tuisekiLink, param);
            this.openNewWindow(linkUrl);
        },
        /**
         * Function settingUrl
         * @param {String} url, url get from DB
         * @param {String} param, param to binding for url
         * Replace param for url
         */
        settingUrl: function(url, param) {
            if(url) {
                if(url.indexOf("[1]") > -1) {
                    return url.replace("[1]", param);
                } else {
                    return url + param;
                }
            }
            return '';
        },

        /**
         * Function openNewWindow
         * @param {String} url, new url
         * お問い合わせリンク押下
         */
        openNewWindow: function(url) {
            if(url) {
                window.open(url);
            }
        },

        formatPrice: function(value){
            return common.formatPrice(value);
        },

    },
    
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = this.$route.query;
        if(queryData != null){
            _this.pt460reqModel.fBaFLG = queryData.fBaFlg;
            _this.pt460reqModel.orderNo = queryData.orderNo;
            _this.pt460reqModel.orderCdTypical = queryData.orderCdTypical;
            _this.pt460reqModel.returnPage = queryData.returnPage;
        }
        if(Object.keys(paramData).length > 0){
            _this.requestBack.ptPageNo = paramData.ptPageNo;
            _this.requestBack.ptPageSize = paramData.ptPageSize;
            _this.requestBack.sKbn = paramData.sKbn;
            _this.requestBack.rKbn = paramData.rKbn;
            _this.requestBack.ptOrderByType = paramData.ptOrderByType;
        }
        _this.tdkIndex = 1;
        _this.frontIndex = 1;
        _this.takeOutIndex = 1; 
    }
}
</script>
<style scoped>
a {
  color: blue;
  text-decoration: none;
}
.barcodeImg {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

</style>